import React, { useContext, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Input from "@amzn/meridian/input";
import { flowHeaders, wip } from "./SettingsConstant";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { SettingsContext } from "./SettingsContext";
import Column from "@amzn/meridian/column";

const NodeTargetsCell = (props) => {
  const target = props.data.target;
  let data = props.data.insights;
  const isUserAuthorisedForSettingsEdit =
    props.data.isUserAuthorisedForSettingsEdit;
  const [value, setValue] = useState("");

  if (Object.keys(data).length === 0 && value !== "") {
    setValue("");
  }

  const onChange = (value) => {
    setValue(value);
    if (value) {
      data[target] = Number(value);
    } else {
      delete data[target];
    }
  };

  return (
    <TableCell>
      <Input
        size="small"
        type="number"
        value={value}
        width="75px"
        onChange={onChange}
        placeholder={target === "WIP_TARGET" ? "%" : "MM"}
        disabled={!isUserAuthorisedForSettingsEdit}
      />
    </TableCell>
  );
};

const FlowView = (props) => {
  const { viewModel, dispatch } = useContext(SettingsContext);
  const flowData = viewModel.settingsData;
  const [targetMap, setTargetMapState] = useState({});
  const isUserAuthorisedForSettingsEdit =
    props.flow.isUserAuthorisedForSettingsEdit;

  useEffect(() => {
    dispatch({
      type: "LOAD_FLOW_DATA",
      data: { dispatcher: dispatch },
    });
  }, []);

  const newTargetMap = (currentMap, newMap) => {
    let updatedMap = {};
    if (currentMap && newMap) {
      const keys = Object.keys(currentMap);
      keys.forEach((key) => {
        updatedMap[key] =
          key in newMap && currentMap[key] !== newMap[key]
            ? newMap[key]
            : currentMap[key];
      });
    }
    return updatedMap;
  };

  const updateFlow = (targetMap) => {
    if (targetMap && Object.keys(targetMap).length > 0) {
      dispatch({
        type: "UPDATE_FLOW_DATA",
        data: {
          dispatcher: dispatch,
          flowData: newTargetMap(flowData.flowData, targetMap),
        },
      });
      setTargetMapState({});
    }
  };

  return (
    <Column spacing="small" className="autoProcesses">
      <Row
        spacingInset="small 400"
        backgroundColor="secondary"
        className="autoProcessesSaveButton"
        alignmentHorizontal="end"
      >
        <Button
          type="tertiary"
          onClick={() => setTargetMapState({})}
          disabled={!isUserAuthorisedForSettingsEdit}
        >
          Cancel
        </Button>
        <Button
          onClick={() => updateFlow(targetMap)}
          type="primary"
          disabled={!isUserAuthorisedForSettingsEdit}
        >
          Save
        </Button>
      </Row>
      <Table
        headerRows={1}
        showDividers={true}
        spacing="medium"
        showStripes={false}
      >
        <TableRow highlightOnHover={true}>
          {flowHeaders.map((header) => {
            return <TableCell>{header}</TableCell>;
          })}
        </TableRow>
        {Object.keys(wip).map((name) => {
          return (
            <TableRow highlightOnHover={true}>
              <TableCell>{name}</TableCell>
              <TableCell>
                {flowData[props.flow.processName][wip[name]]}
              </TableCell>
              <NodeTargetsCell
                data={{
                  insights: targetMap,
                  target: wip[name],
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            </TableRow>
          );
        })}
      </Table>
    </Column>
  );
};
export default injectIntl(FlowView);



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/Flow.js